import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import PreviewIcon from '@mui/icons-material/Preview';
import {
    Box,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
} from '@mui/material';

import { useGallery } from 'hooks/store/useGallery';
import { imageFileStorage } from 'types/api/imageFileStorage';

type ImageListItemProps = {
    item: imageFileStorage;
    onRequestDelete?: () => void;
    onRequestEdit?: () => void;
    onSelect?: () => void;
    selected?: boolean;
};

export const ImageListItem = ({
    item,
    selected,
    onSelect = () => undefined,
    onRequestEdit = () => undefined,
    onRequestDelete = () => undefined,
}: ImageListItemProps): JSX.Element => {
    const { setGallery } = useGallery();

    return (
        <ListItem disablePadding selected={selected}>
            <ListItemButton onClick={() => onSelect()} selected={selected}>
                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ width: '100%' }}
                >
                    <ListItemText primary={item.name} />
                    <Box sx={{ flex: 1 }} />
                    <IconButton onClick={() => onRequestEdit()}>
                        <ModeEditIcon />
                    </IconButton>
                    <IconButton onClick={() => onRequestDelete()}>
                        <DeleteOutlineIcon />
                    </IconButton>
                    <IconButton
                        edge="end"
                        onClick={() =>
                            setGallery({
                                src: item.file,
                                alt: item.name,
                            })
                        }
                    >
                        <PreviewIcon />
                    </IconButton>
                </Stack>
            </ListItemButton>
        </ListItem>
    );
};
